import React, { useState } from "react";
import { Alert, Button, ButtonGroup } from "react-bootstrap";
import { useUpdatePromotionalCode } from "../../hooks/useUpdatePromotionalCode";
import { useDeletePromotionalCode } from "../../hooks/useDeletePromotionalCode";
import { CODE_STATUS } from "utils/promotionalCode";

const PromotionalCodeBulkActions = ({ selectedCodes, onClearSelection }) => {
  const [showConfirm, setShowConfirm] = useState(null);
  const { mutate: updateCode, isPending: isUpdating } = useUpdatePromotionalCode();
  const { mutate: deleteCode, isPending: isDeleting } = useDeletePromotionalCode();

  const selectedCount = selectedCodes?.length || 0;

  if (selectedCount === 0) return null;

  const handleBulkActivate = () => {
    if (window.confirm(`Are you sure you want to activate ${selectedCount} code(s)?`)) {
      selectedCodes.forEach((code) => {
        updateCode({
          id: code.id,
          body: { status: CODE_STATUS.ACTIVE },
        });
      });
      onClearSelection();
    }
  };

  const handleBulkDeactivate = () => {
    if (window.confirm(`Are you sure you want to deactivate ${selectedCount} code(s)?`)) {
      selectedCodes.forEach((code) => {
        updateCode({
          id: code.id,
          body: { status: CODE_STATUS.INACTIVE },
        });
      });
      onClearSelection();
    }
  };

  const handleBulkDelete = () => {
    if (window.confirm(`Are you sure you want to delete ${selectedCount} code(s)? This action cannot be undone.`)) {
      selectedCodes.forEach((code) => {
        deleteCode(code.id);
      });
      onClearSelection();
    }
  };

  const isPending = isUpdating || isDeleting;

  return (
    <Alert variant="info" className="d-flex justify-content-between align-items-center mb-3">
      <span>
        <strong>{selectedCount}</strong> code(s) selected
      </span>
      <ButtonGroup>
        <Button variant="success" size="sm" onClick={handleBulkActivate} disabled={isPending}>
          Activate
        </Button>
        <Button variant="warning" size="sm" onClick={handleBulkDeactivate} disabled={isPending}>
          Deactivate
        </Button>
        <Button variant="danger" size="sm" onClick={handleBulkDelete} disabled={isPending}>
          Delete
        </Button>
        <Button variant="secondary" size="sm" onClick={onClearSelection} disabled={isPending}>
          Clear Selection
        </Button>
      </ButtonGroup>
    </Alert>
  );
};

export default PromotionalCodeBulkActions;

